var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"用户编辑","visible":_vm.state,"width":"30%","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.state=$event}}},[_c('tz-form',{attrs:{"width":"80px","formConfig":_vm.formConfig,"formBtns":_vm.formBtns,"row":_vm.dataRight},on:{"submit":_vm.submitFn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }